import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useAnalytics } from './use-analytics';

/**
 * Hook that automatically tracks page views when the component mounts or route changes
 * Should be used in route components to track navigation
 *
 * @param pageTitle - Optional custom page title (defaults to document.title)
 *
 * @example
 * ```tsx
 * const Dashboard = () => {
 *   usePageView('Dashboard');
 *   return <div>Dashboard content</div>;
 * };
 * ```
 */
export const usePageView = (pageTitle?: string) => {
  const { trackPageView } = useAnalytics();
  const location = useLocation();

  useEffect(() => {
    const title = pageTitle ?? document.title;
    trackPageView(location.pathname, title);
  }, [location.pathname, pageTitle, trackPageView]);
};
